var map = {
	"./1.1.svg": "4fab",
	"./1.2.svg": "ef6c",
	"./1.3.svg": "977b",
	"./1.4.svg": "2aa2",
	"./1.5.svg": "e01d",
	"./1.a.svg": "5881",
	"./1.b.svg": "35c2",
	"./10.1.svg": "3aa5",
	"./10.2.svg": "162b",
	"./10.3.svg": "4608",
	"./10.4.svg": "90e2",
	"./10.5.svg": "1a5f",
	"./10.6.svg": "0b9e",
	"./10.7.svg": "8395",
	"./10.a.svg": "b89b",
	"./10.b.svg": "290d",
	"./10.c.svg": "49da",
	"./11.1.svg": "8256",
	"./11.2.svg": "27f5",
	"./11.3.svg": "579c",
	"./11.4.svg": "514d",
	"./11.5.svg": "477d",
	"./11.6.svg": "0878",
	"./11.7.svg": "ad82",
	"./11.a.svg": "68e3",
	"./11.b.svg": "49e6",
	"./11.c.svg": "cb0f",
	"./12.1.svg": "2a09",
	"./12.2.svg": "845a",
	"./12.3.svg": "5b1c",
	"./12.4.svg": "489b",
	"./12.5.svg": "a8a3",
	"./12.6.svg": "b3a5",
	"./12.7.svg": "8c04",
	"./12.8.svg": "3cdb",
	"./12.a.svg": "ea4a",
	"./12.b.svg": "9a4d",
	"./12.c.svg": "966d",
	"./13.1.svg": "199a",
	"./13.2.svg": "a149",
	"./13.3.svg": "ff51",
	"./13.a.svg": "90ee",
	"./13.b.svg": "37b5",
	"./14.1.svg": "4773",
	"./14.2.svg": "bc67",
	"./14.3.svg": "6890",
	"./14.4.svg": "529d",
	"./14.5.svg": "c2f0",
	"./14.6.svg": "d617",
	"./14.7.svg": "aea4",
	"./14.a.svg": "f461",
	"./14.b.svg": "77be",
	"./14.c.svg": "6229",
	"./15.1.svg": "afb4",
	"./15.2.svg": "d33b",
	"./15.3.svg": "0234",
	"./15.4.svg": "997f",
	"./15.5.svg": "916b",
	"./15.6.svg": "1639",
	"./15.7.svg": "40da",
	"./15.8.svg": "859a",
	"./15.9.svg": "936c",
	"./15.a.svg": "c5d4",
	"./15.b.svg": "1ab0",
	"./15.c.svg": "8b31",
	"./16.1.svg": "ae6a",
	"./16.10.svg": "f819",
	"./16.2.svg": "76c3",
	"./16.3.svg": "a447",
	"./16.4.svg": "c0e3",
	"./16.5.svg": "e828",
	"./16.6.svg": "5f73",
	"./16.7.svg": "8539",
	"./16.8.svg": "90bf",
	"./16.9.svg": "871a",
	"./16.a.svg": "1547",
	"./16.b.svg": "7684",
	"./17.1.svg": "7ba3",
	"./17.10.svg": "4b05",
	"./17.11.svg": "47d6",
	"./17.12.svg": "4197",
	"./17.13.svg": "a77a",
	"./17.14.svg": "e978",
	"./17.15.svg": "1bbb",
	"./17.16.svg": "9267",
	"./17.17.svg": "3843",
	"./17.18.svg": "6971",
	"./17.19.svg": "61d1",
	"./17.2.svg": "743e",
	"./17.3.svg": "8c73",
	"./17.4.svg": "6c35",
	"./17.5.svg": "c734",
	"./17.6.svg": "9426",
	"./17.7.svg": "ea13",
	"./17.8.svg": "c618",
	"./17.9.svg": "6bc8",
	"./2.1.svg": "0e63",
	"./2.2.svg": "e76a",
	"./2.3.svg": "355e",
	"./2.4.svg": "7e5c",
	"./2.5.svg": "18ae",
	"./2.a.svg": "b3f0",
	"./2.b.svg": "f11a",
	"./2.c.svg": "42c5",
	"./3.1.svg": "18d7",
	"./3.2.svg": "0e59",
	"./3.3.svg": "cbd0",
	"./3.4.svg": "92e3",
	"./3.5.svg": "764d",
	"./3.6.svg": "0316",
	"./3.7.svg": "0f3e",
	"./3.8.svg": "39ed",
	"./3.9.svg": "67c1",
	"./3.a.svg": "8213",
	"./3.b.svg": "98f3",
	"./3.c.svg": "9e4b",
	"./3.d.svg": "5a9e",
	"./4.1.svg": "aaa9",
	"./4.2.svg": "be0c",
	"./4.3.svg": "3fd4",
	"./4.4.svg": "8fb1",
	"./4.5.svg": "62e7",
	"./4.6.svg": "ec1b",
	"./4.7.svg": "1b01",
	"./4.a.svg": "55d3",
	"./4.b.svg": "09f4",
	"./4.c.svg": "3339",
	"./5.1.svg": "84bf",
	"./5.2.svg": "7d15",
	"./5.3.svg": "ad9d",
	"./5.4.svg": "8091",
	"./5.5.svg": "fcb9",
	"./5.6.svg": "2709",
	"./5.a.svg": "b9e0",
	"./5.b.svg": "e43a",
	"./5.c.svg": "aedf",
	"./6.1.svg": "9b6e",
	"./6.2.svg": "b383",
	"./6.3.svg": "5374",
	"./6.4.svg": "99b6",
	"./6.5.svg": "a079",
	"./6.6.svg": "9819",
	"./6.a.svg": "5b33",
	"./6.b.svg": "ed77",
	"./7.1.svg": "9712",
	"./7.2.svg": "40db",
	"./7.3.svg": "4594",
	"./7.a.svg": "d3ac",
	"./7.b.svg": "c1b6",
	"./8.1.svg": "e9f7",
	"./8.10.svg": "9ae0",
	"./8.2.svg": "1b50",
	"./8.3.svg": "a832",
	"./8.4.svg": "d7b0",
	"./8.5.svg": "322a",
	"./8.6.svg": "97be",
	"./8.7.svg": "836d",
	"./8.8.svg": "3667",
	"./8.9.svg": "cad5",
	"./8.a.svg": "def2",
	"./8.b.svg": "c47a",
	"./9.1.svg": "c30d",
	"./9.2.svg": "ac26",
	"./9.3.svg": "5521",
	"./9.4.svg": "7431",
	"./9.5.svg": "d902",
	"./9.a.svg": "107e",
	"./9.b.svg": "39bd",
	"./9.c.svg": "2f2b",
	"./actions.svg": "87ae",
	"./arrow-down.svg": "b4c8",
	"./arrow-left.svg": "f6db",
	"./arrow-right.svg": "8281",
	"./arrow-up.svg": "4a80",
	"./bubbles.svg": "4d3b",
	"./checkmark.svg": "ca3f",
	"./cloud-download.svg": "19e0",
	"./cloud-upload.svg": "a676",
	"./effect-1.svg": "0a18",
	"./effect-2.svg": "c334",
	"./effect0.svg": "72c7",
	"./effect1.svg": "5e21",
	"./effect2.svg": "b49d",
	"./effect3.svg": "0d80",
	"./enlarge.svg": "0bf3",
	"./equalizer.svg": "d562",
	"./flag.svg": "cc69",
	"./flags/cn.svg": "033a",
	"./flags/da.svg": "2caf",
	"./flags/de.svg": "63d7",
	"./flags/en.svg": "2b06",
	"./flags/es.svg": "37fe",
	"./flags/fr.svg": "2d7a",
	"./flags/no.svg": "38b2",
	"./flags/se.svg": "d0dd",
	"./global-goals.svg": "c5e3",
	"./heart.svg": "6768",
	"./info-simple.svg": "b5ae",
	"./info.svg": "69d9",
	"./logo.svg": "a5f7",
	"./logoOLD.svg": "e8ee",
	"./niraslogo.svg": "7c46",
	"./pdf-file.svg": "a613",
	"./pencil.svg": "be21",
	"./printer.svg": "0097",
	"./sdg-wheel-black.svg": "545d",
	"./sdg-wheel.svg": "b9b2",
	"./sdgs/da/SDG-1.svg": "2c8e",
	"./sdgs/da/SDG-10.svg": "f026",
	"./sdgs/da/SDG-11.svg": "828a",
	"./sdgs/da/SDG-12.svg": "84c6",
	"./sdgs/da/SDG-13.svg": "795f",
	"./sdgs/da/SDG-14.svg": "163c",
	"./sdgs/da/SDG-15.svg": "0960",
	"./sdgs/da/SDG-16.svg": "eac1",
	"./sdgs/da/SDG-17.svg": "52da",
	"./sdgs/da/SDG-2.svg": "26e2",
	"./sdgs/da/SDG-3.svg": "9b3a",
	"./sdgs/da/SDG-4.svg": "5649",
	"./sdgs/da/SDG-5.svg": "06c3",
	"./sdgs/da/SDG-6.svg": "5371",
	"./sdgs/da/SDG-7.svg": "0932",
	"./sdgs/da/SDG-8.svg": "f240",
	"./sdgs/da/SDG-9.svg": "7ac9",
	"./sdgs/en/SDG-1.svg": "2c80",
	"./sdgs/en/SDG-10.svg": "9403",
	"./sdgs/en/SDG-11.svg": "0e53",
	"./sdgs/en/SDG-12.svg": "da47",
	"./sdgs/en/SDG-13.svg": "ba74",
	"./sdgs/en/SDG-14.svg": "0e91",
	"./sdgs/en/SDG-15.svg": "ba24",
	"./sdgs/en/SDG-16.svg": "1098",
	"./sdgs/en/SDG-17.svg": "392b",
	"./sdgs/en/SDG-2.svg": "3b80",
	"./sdgs/en/SDG-3.svg": "7980",
	"./sdgs/en/SDG-4.svg": "3827",
	"./sdgs/en/SDG-5.svg": "b0a6",
	"./sdgs/en/SDG-6.svg": "1540",
	"./sdgs/en/SDG-7.svg": "3aad",
	"./sdgs/en/SDG-8.svg": "2dab",
	"./sdgs/en/SDG-9.svg": "b183",
	"./sdgs/fr/SDG-1.svg": "1a27",
	"./sdgs/fr/SDG-10.svg": "5fa1",
	"./sdgs/fr/SDG-11.svg": "1a44",
	"./sdgs/fr/SDG-12.svg": "b7ac",
	"./sdgs/fr/SDG-13.svg": "68a0",
	"./sdgs/fr/SDG-14.svg": "bd69",
	"./sdgs/fr/SDG-15.svg": "94a6",
	"./sdgs/fr/SDG-16.svg": "5839",
	"./sdgs/fr/SDG-17.svg": "5deb",
	"./sdgs/fr/SDG-2.svg": "7ac5",
	"./sdgs/fr/SDG-3.svg": "80a7",
	"./sdgs/fr/SDG-4.svg": "bc92",
	"./sdgs/fr/SDG-5.svg": "ec3c",
	"./sdgs/fr/SDG-6.svg": "0b1a",
	"./sdgs/fr/SDG-7.svg": "b9e1",
	"./sdgs/fr/SDG-8.svg": "2683",
	"./sdgs/fr/SDG-9.svg": "0798",
	"./un.svg": "bd1b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";